import Instafeed from 'instafeed.js'

// id for artisanflooring - via
// https://smashballoon.com/instagram-feed/find-instagram-user-id/
const INSTAGRAM_ID = 507622723

// To generate a new token, log in to instagram as artisanflooring and go to
// http://instagram.pixelunion.net/
const INSTAGRAM_TOKEN = '507622723.1677ed0.a58f4abee6db40eb861eabf1ef0b8c9a'

function instafeed (el, options = {}) {
  const {
    limit = 5,
    hashtag = ''
  } = options

  let foundImages = 0

  const feedOptions = {
    target: el,
    get: 'user',
    userId: [INSTAGRAM_ID],
    template: '<div class="item"><a href="{{link}}" style="background-image: url({{image}})"></a></div>',
    // clientId: CLIENT_ID
    accessToken: INSTAGRAM_TOKEN,
    // need to retrieve extras if hashtag filtering
    limit: hashtag ? limit * 10 : limit,
    resolution: 'standard_resolution',
    sortBy: 'most-recent',
    filter: function (image) {
      if (!hashtag) {
        return true
      }
      if (image.tags.indexOf(hashtag) >= 0 && foundImages < limit) {
        foundImages += 1
        return true
      }
      return false
    }
  }

  return new Promise((resolve, reject) => {
    feedOptions.after = () => {
      el.classList.add('insta-done')
      resolve()
    }
    const feed = new Instafeed(feedOptions)
    feed.run()
  })
}

export default instafeed



// WEBPACK FOOTER //
// ./assets/j/src/instafeed.js